import { IProductService } from "@/lib/content-service/interfaces/IProductService"

export class ContentServiceClient {
    constructor(public product: IProductService) {}
}
